import React, { useState, ChangeEvent } from "react";
import { HStack, VStack, Select, Box, Text, Button, 
  Textarea, useDisclosure, AlertDialog, AlertDialogOverlay, AlertDialogContent, AlertDialogHeader, AlertDialogBody, AlertDialogFooter 
} from '@chakra-ui/react';
import { Work } from "@/pbgen/v1/main_pb";
//import {client} from "@/client"
import {client, baseUrl} from "@/client"
import { NavigateFunction } from "react-router-dom"; // useNavigate の型

import { useLocation } from "react-router-dom";
import './ItemComponent.css';


interface ItemComponentProps {
  item: Work;
  privUser: boolean;
  mainColor: string;
  bearerToken: () => string;
  navigate: NavigateFunction;
  onDelete: () => void;
}

type ImageButtonProps = {
  onClick: () => void; // onClickの型を指定
  imageUrl: string;
  altText: string;
  buttonText?: string; // buttonTextをオプショナルに
};


export const WorkComponent: React.FC<ItemComponentProps> = ({ item, privUser, mainColor, bearerToken, navigate, onDelete }) => {
  const [localItem, setLocalItem] = useState<Work>(item);
  const { isOpen, onOpen, onClose } = useDisclosure()
  const cancelRef = React.useRef<HTMLButtonElement | null>(null)
  const [isEditMode, setEditMode] = useState(false);
  const [isCanNotUpdate, setIsCanNotUpdate] = useState<boolean>((item.permission & 1024) > 0);
  

  //console.log(baseUrl);
  //console.log(privUser);
  //console.log(item);
  //console.log(localItem);

  // ItemComponent の実装
  const handleClick = async () => {

      let newstatus = localItem.status;
      switch (localItem.status) {
        case "not_started":
          newstatus = 'in_progress';
          break;
        case "in_progress":
          newstatus = 'fix';
          break;
        case "fix":
          if (privUser) {
            newstatus = 'completed';
          } else {
            newstatus = 'not_started';
          }
          break;
        case "completed":
          if (privUser) {
            newstatus = 'not_started';
          }
          break;
        default:
          break;
      }
      
      const statussetDate = new Date()      
      //console.log("statussetDate", statussetDate);
      const newWork = { ...localItem, status: newstatus, statussetRfc3339:statussetDate.toISOString() } as Work;
      setLocalItem(newWork);
      //console.log("fa18bf3", newWork);

      if (!isCanNotUpdate) {
        //更新保存不可教材はステータス変更しない
        try {
          const resp = await client.saveWork({
            bearerToken: bearerToken(),
            work: newWork,
          });
          console.log('fa85a52', resp.error);
        } catch (error) {
          console.error('Error:', error);
        }  
      }
  };

  const handleOpen = async () => {

    if (!privUser) {
      const openDate = new Date()
      //console.log("openDate", openDate);
      const newWork = { ...localItem, openAtRfc3339:openDate.toISOString() } as Work;
      setLocalItem(newWork);
      //console.log("fa18bf3", newWork);
  
      try {
        const resp = await client.saveWork({
          bearerToken: bearerToken(),
          work: newWork,
        });
        console.log('fa85a52', resp.error);
      } catch (error) {
        console.error('Error:', error);
      }
    }

    navigate(`./${localItem.projectId}`, { relative: "path" } );
  };

  const formatDate = (rfc3339String: string) => {
    const date = new Date(rfc3339String);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
/*
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
  
    return `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`;
*/
    return (
      <>
      {year}年<br />
      {month}月{day}日
      </>
    );
  };

  /*
  var titleName = localItem.title;
  if (titleName === null || titleName === "") {
    const fileNameWithExt = localItem.path.split('/').pop() || '';
    const fileNameWithoutExt = fileNameWithExt.split('.').slice(0, -1).join('.');
    const words = fileNameWithoutExt.split('_');
    titleName = words[1] + "_" + words[2];
  }
    */

  return (

    <HStack key={localItem.eid} className={`item_component " ${(localItem.status === "completed") ? "comp" : ""}`}  p={4}>

    <VStack>
      <button className="image_button" onClick={ () => handleClick() }>
          <img src={`/ap/img/${localItem.status}.png`} 
          alt="じょうたい" />
      </button>
    </VStack>

    <VStack align="start">
    
      <div className="item_component_name" dangerouslySetInnerHTML={{ __html: localItem.title }} />

      <HStack>

        <img className="item_component_thumbnail" src={`${baseUrl}/scratch_api/assets/${localItem.thumbnailId}`} />
 
        <VStack className="item_component_renrakubox">

          <textarea className="item_component_renrakutext"
            value={localItem.note}
            disabled={!isEditMode}
            style={{
              display: "block",
              width: "300px",
              height: isEditMode ? "300px" : "96px",
              resize: "none",
              fontSize: "16px",
            }}
            onChange={
              (e: ChangeEvent<HTMLTextAreaElement>) => {
              setLocalItem({ ...localItem, note: e.target.value } as Work);
              }
            }
          />

{/*
      <Textarea className="item_component_renrakutext" disabled value={localItem.note} onChange={
          (e: ChangeEvent<HTMLTextAreaElement>) => {
            setLocalItem({ ...localItem, note: e.target.value } as Work);
            buttonEnabled || setButtonEnabled(true);
          }
        }></Textarea>
*/}

          <Button className="item_component_renrakubutton" onClick={async () => {

            if (isEditMode) {
              if (isCanNotUpdate) {
                //更新保存不可教材の場合は連絡テキストをクリア
                localItem.note = "";
              } else {
                //連絡テキストをクリアを保存
                const newWork = { ...localItem, note: localItem.note } as Work;
                setLocalItem(newWork);
                const resp = await client.saveWork({
                  bearerToken: bearerToken(),
                  work: newWork,  
                })
              }
            setEditMode(false);
          } else {
            setEditMode(true);
          }
        }}>
            {isEditMode 
              ? (isCanNotUpdate ? "とじてクリア" : "ほぞん") 
              : "れんらく"
            }
          </Button>


        {/*
        <Button className="item_component_renrakubutton" onClick={async () => {

        }}>よむ・かく</Button>


        <Button className="item_component_renrakubutton" isDisabled={!buttonEnabled} onClick={async () => {
          const newWork = { ...localItem, note: localItem.note } as Work;
          setLocalItem(newWork);
          const resp = await client.saveWork({
            bearerToken: bearerToken(),
            work: newWork,
          });
          setButtonEnabled(false);
        }}>保存</Button>
*/}

        </VStack>
      </HStack>
    </VStack>

{/*
      <Button className="item_component_openbutton" onClick={() => { navigate(`./${localItem.projectId}`, { relative: "path" }) }}>ひらく</Button>
*/}

      <VStack align="center">

        <Button className="item_component_openbutton" onClick={ () => handleOpen() }>ひらく</Button>

        {(localItem.createdAtRfc3339 !== localItem.openAtRfc3339) ?
          <>
          <div className="item_component_opentext">ひらいた日<br />{formatDate(localItem.openAtRfc3339)}</div>
          </>
          : <></>
        }
      </VStack>


      {privUser ?
        <>
          <Button height={"4em"} onClick={onOpen}>削除</Button>
          <AlertDialog isOpen={isOpen} onClose={onClose} leastDestructiveRef={cancelRef}>
            <AlertDialogOverlay>
              <AlertDialogContent width="auto" maxW="fit-content" minW="480px">
              <AlertDialogHeader>
                  教材の削除
                </AlertDialogHeader>
                <AlertDialogBody className="item_component_remove">
                  <span>この生徒の</span>
                  <HStack>
                    <img src={`${baseUrl}/scratch_api/assets/${localItem.thumbnailId}`} />
                    <span dangerouslySetInnerHTML={{ __html: localItem.title ?? '' }}></span>
                  </HStack>
                  <span>を本当に削除しますか？</span>
                </AlertDialogBody>
                <AlertDialogFooter>
                  <Button ref={cancelRef} onClick={onClose}>
                    キャンセル
                  </Button>
                  <Button  ml={3} onClick={async () => {
                    const resp = await client.deleteWork({
                      bearerToken: bearerToken(),
                      workEid: localItem.eid,
                    });
                    if (resp.error === undefined) {
                      onDelete();
                    }
                  }}>削除</Button>
                </AlertDialogFooter>
              </AlertDialogContent>
            </AlertDialogOverlay>
          </AlertDialog>
        </>
        : <></>}
    </HStack>
  );
};
